import React from 'react';
import LeaderboardTableItem, {
  LeaderboardTableItemProps,
} from '@components/leaderboard/list/LeaderboardTableItem';
import ShowMoreDivider from '@components/leaderboard/ShowMoreDivider';

export interface LeaderboardTableProps {
  topLeaderboard: LeaderboardTableItemProps[];
  leaderboardList: LeaderboardTableItemProps[];
  bottomLeaderboard: LeaderboardTableItemProps[];
  showMore: boolean;
  onShowMore: () => void;
}

const LeaderboardTable = ({
  topLeaderboard,
  leaderboardList,
  bottomLeaderboard,
  showMore,
  onShowMore,
}: LeaderboardTableProps) => {
  return (
    <>
      <div>
        {topLeaderboard.map(item => (
          <LeaderboardTableItem {...item} key={item.standing} />
        ))}
      </div>
      {!showMore && leaderboardList.length > 0 ? (
        <div className={'mb-4'}>
          <ShowMoreDivider onShowMore={onShowMore} />
        </div>
      ) : null}
      <div>
        {bottomLeaderboard.map(item => (
          <LeaderboardTableItem {...item} key={item.standing} />
        ))}
      </div>
      <div className={'max-lg:h-[70px] lg:h-[16px]'}></div>
    </>
  );
};

export default LeaderboardTable;
